import { iconMap } from '../maps/iconMap';
import { colors } from '../maps/colors';

export default function IconBtn(props) {

    const { customtheme } = props;

    const Icon = iconMap[props.children];

    let style = {};

    switch (customtheme) {
        case 'normal':
            break;
        default:
            style = { color: colors.GREEN, ...props.style };
    }

    return (
        <Icon {...props} style={{ ...style }} />
    )
}